import { createAction, props } from '@ngrx/store';
import { type } from '@app/util/util';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { SearchParamFromType } from '@search-bar/entities/search-type';
import { RecentSearchDataType } from '@design-system/components/molecules/recent-search/entities/recent-search.types';

export const fetchRecentSearchesAction = createAction(
  type('[RecentSearches/API] Fetch recent searches data')
);
export const fetchRecentSearchesPlaceMapperSuccessAction = createAction(
  type('[RecentSearches/API] Fetch searches place mapper success'),
  props<{ response: RecentSearchModel[] }>()
);
export const fetchRecentSearchesSuccessAction = createAction(
  type('[RecentSearches/API] Fetch recent searches data success'),
  props<{ response: RecentSearchModel[] }>()
);
export const deleteRecentSearchesAction = createAction(
  type('[RecentSearches/API] Delete home recent searches')
);
export const deleteRecentSearchesSuccessAction = createAction(
  type('[RecentSearches/API] Delete home recent searches success')
);
export const saveRecentSearchAction = createAction(
  type('[RecentSearches/API] Save recent search'),
  props<{ from: SearchParamFromType, dataType: RecentSearchDataType, payload: RecentSearchModel }>()
);
export const saveRecentSearchSuccessAction = createAction(
  type('[RecentSearches/API] Save recent search success')
);
